export const dashboardGoalMessages = {
  preGoal: [
    '_dashboard_usage_goals_pre_almost_there',
    '_dashboard_usage_goals_pre_good_job',
    '_dashboard_usage_goals_pre_just_little_more',
    '_dashboard_usage_goals_pre_keep_going',
    '_dashboard_usage_goals_pre_looking_good',
    '_dashboard_usage_goals_pre_mobile_app',
    '_dashboard_usage_goals_pre_you_can'
  ],
  preGoalWithTutoring: [
    '_dashboard_usage_goals_pre_almost_there',
    '_dashboard_usage_goals_pre_good_job',
    '_dashboard_usage_goals_pre_just_little_more',
    '_dashboard_usage_goals_pre_keep_going',
    '_dashboard_usage_goals_pre_looking_good',
    '_dashboard_usage_goals_pre_mobile_app',
    '_dashboard_usage_goals_pre_you_can',
    '_dashboard_usage_goals_pre_dont_forget'
  ],
  postGoal: [
    '_dashboard_usage_goals_post_amazing',
    '_dashboard_usage_goals_post_did_you',
    '_dashboard_usage_goals_post_fantastic',
    '_dashboard_usage_goals_post_great_job',
    '_dashboard_usage_goals_post_wow'
  ]
};

export const goalsDayOptions = [
  { value: '1' },
  { value: '2' },
  { value: '3' },
  { value: '4' },
  { value: '5' },
  { value: '6' },
  { value: '7' }
];

export const goalsMinutesOptions = [
  { value: '10' },
  { value: '20' },
  { value: '30' },
  { value: '40' },
  { value: '50' },
  { value: '60' },
  { value: '70' },
  { value: '80' },
  { value: '90' },
  { value: '100' },
  { value: '110' },
  { value: '120' }
];



// WEBPACK FOOTER //
// ./src/modules/launchpad/services/goals-helpers.js